"use strict";

angular.module("customer")
.component("deactivateFilters", {
    templateUrl: require("./deactivate-filters.component.html"),
    bindings: {
        text: "<"
    },
    controller: function($scope, $rootScope, $state, $resource, UserService, appConfig) {
        var _this = this;
        this.preferredMode = $rootScope.preferredMode;
        this.promotionMode = $rootScope.promotionMode;

        this.deactivateFilter = function() {
            var resource = $resource(appConfig.API_SERVER + "/auth/customer/:id/mode/", {id: "@id"}, {
                update: {
                    method: "PATCH",
                    ignoreLoadingBar: true
                }
            });

            UserService.isUserFetched().then(function onSuccess(user) {
                if (!user.customer) {
                    return
                }

                resource.get({id: user.customer.id}, function(customer) {
                    customer.preferred_enabled = false;
                    customer.promotion_enabled = false;
                    customer.$update().then(function(data) {
                        $state.reload().then(function() {
                            $rootScope.preferredMode = data.preferred_enabled;
                            $rootScope.promotionMode = data.promotion_enabled;
                        });
                    });
                });
            });
        };

        $scope.$on("UserUpdated", function(event) {
            _this.preferredMode = $rootScope.preferredMode;
            _this.promotionMode = $rootScope.promotionMode;
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/deactivate-filters/deactivate-filters.component.js
// module id = 835
// module chunks = 0